import { Component, inject } from '@angular/core';
import { TranslatePipe, TranslateService } from '@ngx-translate/core';

import { AuthService } from '@user/services/auth.service';
import { CommonModule } from '@angular/common';
import { LoadingOverlayComponent } from '@shared/components/loading-overlay/loading-overlay.component';
import { NgToastComponent } from 'ng-angular-popup';
import { RouterOutlet } from '@angular/router';

// eslint-disable-next-line @angular-eslint/prefer-on-push-component-change-detection
@Component({
  selector: 'app-root',
  imports: [RouterOutlet, CommonModule, NgToastComponent, LoadingOverlayComponent, TranslatePipe],
  templateUrl: './app.html',
  styleUrl: './app.scss'
})
export class App {
  auth = inject(AuthService);
  private translate = inject(TranslateService);

  constructor() {
    this.translate.addLangs(['sq', 'en']);
    this.translate.setFallbackLang('en');
    this.translate.use(localStorage.getItem('language') || 'en');
  }
}
